import { injectReducer } from '@modules/reducers'

// Sync route definition
export default (store: Store): RouteConfig => ({
  path: '/ia-agent',
  layout: true,
  getComponent: async () => {
    //console.log("CARGA DINAMICA")
    const IAAgentLayout = await import(
      /* webpackChunkName: "ia-agent-modules" */ './IAAgent'
    )
    const { reducer, rootSagas, } = await import(
      /* webpackChunkName: "ia-agent-modules" */ './IAAgentModule'
    )

    injectReducer(store, { key: 'iaAgent', reducer, })
    //injectSagasCheck(store, rootSagas)

    return {
      children: IAAgentLayout.default,
    }
  }
})

